export default "__VITE_ASSET__d84134fc__"